import React, { useState } from 'react';
import { Layout, Modal } from 'antd';
import { TrademarkOutlined, PhoneFilled, MailFilled, EnvironmentFilled } from '@ant-design/icons';
import PrivacyPolicyContent from './PrivacyPolicyContent';

const { Footer } = Layout;

const styles = {
  footer: {
    backgroundColor: '#001529',
    color: 'white',
    padding: '32px 24px',
  },
  brandRow: {
    display: 'flex',
    // gap и align-items — в index.sass (.app-footer-brand-row), иначе инлайн перебивает центрирование на малых экранах
  },
  trademarkIcon: {
    background: 'rgba(255,255,255,0.12)',
    borderRadius: 12,
    width: 56,
    height: 56,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 28,
    color: '#40a9ff',
    boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
  },
  brandTitle: {
    fontWeight: 700,
    fontSize: 18,
    marginBottom: 4,
  },
  brandSubtitle: {
    color: 'rgba(255,255,255,0.75)',
    marginBottom: 4,
  },
  smallText: {
    color: 'rgba(255,255,255,0.65)',
    marginBottom: 8,
    fontSize: 13,
  },
  sectionTitle: {
    color: '#c1d7ff',
    fontWeight: 700,
    marginBottom: 8,
    letterSpacing: 0.2,
  },
  link: {
    color: '#40a9ff',
    textDecoration: 'none',
  },
  linkMuted: {
    color: 'rgba(255,255,255,0.75)',
    textDecoration: 'none',
  },
  contactsBlock: {
    display: 'grid',
    gap: 10,
  },
  contactRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: 'white',
  },
  messengerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginTop: 12,
  },
  skolkovo: {
    width: 160,
    borderRadius: 8,
    background: 'white',
    padding: 8,
  },
  legal: {
    marginTop: 24,
    fontSize: 12,
    color: 'rgba(255,255,255,0.45)',
  },
  policyButton: {
    padding: 0,
    margin: 0,
    border: 'none',
    background: 'none',
    color: 'rgba(255,255,255,0.75)',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  modalTitle: {
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
  },
  modalStyle: {
    top: 40,
  },
  modalBody: {
    maxHeight: '60vh',
    overflowY: 'auto',
    padding: '20px 28px',
    background: 'var(--theme-cta-bg)',
    borderRadius: 12,
  },
};

const AppFooter = () => {
  const year = new Date().getFullYear();
  const [isPolicyOpen, setPolicyOpen] = useState(false);

  return (
    <Footer style={styles.footer}>
      <Modal
        open={isPolicyOpen}
        onCancel={() => setPolicyOpen(false)}
        onOk={() => setPolicyOpen(false)}
        centered
        title={<div style={styles.modalTitle}>Политика конфиденциальности</div>}
        width={700}
        style={styles.modalStyle}
        bodyStyle={styles.modalBody}
        maskStyle={{ backdropFilter: 'blur(3px)' }}
        okText="Закрыть"
        cancelButtonProps={{ style: { display: 'none' } }}
      >
        <PrivacyPolicyContent />
      </Modal>

      <div className="app-footer-grid">
        <div>
          <div className="app-footer-brand-row" style={styles.brandRow}>
            <div className="app-footer-trademark-icon" style={styles.trademarkIcon}>
              <TrademarkOutlined />
            </div>
            <div>
              <div style={styles.brandTitle}>ООО «ИИП ИС»</div>
              <div style={styles.brandSubtitle}>Сервис поиска товарных знаков</div>
              <div style={styles.smallText}>ИНН 9731135673</div>
              <div style={styles.smallText}>ОГРН 1247700403389</div>
              <button type="button" style={styles.policyButton} onClick={() => setPolicyOpen(true)}>
                Политика конфиденциальности
              </button>
            </div>
          </div>
          <div style={styles.legal}>© {year} Сервис поиска товарных знаков</div>
        </div>

        <div>
          <div style={styles.sectionTitle}>Контакты</div>
          <div style={styles.contactsBlock}>
            <div style={styles.smallText}>Звонок по России бесплатный</div>
            <div className="app-footer-contact-row" style={styles.contactRow}>
              <PhoneFilled />
              <a style={styles.link} href="tel:+74993221284" data-type="tel">
                8 (499) 322-12-84
              </a>
            </div>
            <div className="app-footer-contact-row" style={styles.contactRow}>
              <PhoneFilled />
              <button type="button" className="popup-form-262" style={{ ...styles.linkMuted, background: 'none', border: 'none', cursor: 'pointer', padding: 0, font: 'inherit' }}>
                Обратный звонок
              </button>
            </div>
            <div className="app-footer-contact-row" style={styles.contactRow}>
              <MailFilled />
              <a style={styles.link} href="mailto:office@prointy.ru">
                office@prointy.ru
              </a>
            </div>
            <div className="app-footer-contact-row" style={styles.contactRow}>
              <EnvironmentFilled />
              <span style={styles.linkMuted}>124482, г. Москва, г. Зеленоград, корпус 305</span>
            </div>
          </div>
        </div>

        <div className="app-footer-col-skolkovo">
          <img
            src="/images/skolkovo-optimized.png"
            alt="Резидент Сколково"
            style={styles.skolkovo}
          />
          <div style={{ marginTop: 16 }}>
            <div style={styles.sectionTitle}>Мессенджеры</div>
            <div className="app-footer-messenger-row" style={styles.messengerRow}>
              <a
                href="https://wa.me/79919879839?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%A5%D0%BE%D1%87%D1%83%20%D0%B7%D0%B0%D1%84%D0%B8%D0%BA%D1%81%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D1%82%D1%8C%20%D0%BD%D0%B0%D1%80%D1%83%D1%88%D0%B5%D0%BD%D0%B8%D0%B5"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/images/icon-whatsapp-optimized.png"
                  alt="WhatsApp"
                  style={{ width: 32, height: 32 }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Footer>
  );
};

export default AppFooter;


